import axios from "axios";
import config from "../config";
import type { LLMModelConfig, LLMModel } from "../lib/types";

export type { LLMModel };

export type LLMModelsOutput = {
  llm_models: LLMModel[];
};

export const listLlmModels = async (token: string): Promise<LLMModelsOutput> => {
  const response = await axios.get<LLMModelsOutput>(`${config.apiUrl}/llm_models`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const listLLMModelConfigs = async (token: string): Promise<LLMModelConfig[]> => {
  const response = await axios.get<LLMModelConfig[]>(`${config.apiUrl}/llm-model-configs`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const getLLMModelConfig = async (token: string, id: string): Promise<LLMModelConfig> => {
  const response = await axios.get<LLMModelConfig>(`${config.apiUrl}/llm-model-configs/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const createLLMModelConfig = async (
  token: string,
  configData: LLMModelConfig,
): Promise<LLMModelConfig> => {
  const response = await axios.post<LLMModelConfig>(
    `${config.apiUrl}/llm-model-configs`,
    configData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};

export const updateLLMModelConfig = async (
  token: string,
  configData: LLMModelConfig,
): Promise<LLMModelConfig> => {
  const response = await axios.put<LLMModelConfig>(
    `${config.apiUrl}/llm-model-configs/${configData.id}`,
    configData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};

export const deleteLLMModelConfig = async (token: string, id: string): Promise<void> => {
  await axios.delete(`${config.apiUrl}/llm-model-configs/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
